/**
 * Csv Schema of OcorrenciaTrackingResponsavel
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {TipoVeiculo} from '@/model/resource/TipoVeiculo'

/* TODO: review generated schema */
export class CsvTipoVeiculoSchema extends Schema {
  readonly name = 'CsvTipoVeiculo'

  readonly fieldSet: FieldSet<TipoVeiculo> = {
    idTipoVeiculo: schema => schema.model.idTipoVeiculo,
    nome: schema => schema.model.nome,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
